<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget @tab="switchTab" activeTab="others" />

      <div class="tab-options">
        <b-button type="is-primary" @click="toggleModal = true">ADD NEW</b-button>
      </div>
    </div>
    <div class="wrapper-body" v-if="!loading && allData.length > 0" :class="{ activeSide: $store.state.sidebar }">
      <dataCard @edit="edit(data)" @deleteMedia="deleteMedia(data)" v-for="(data, index) in allData" :key="index"
        :dataObj='data' />
    </div>
    <div v-else>
      <widgetNotfound v-if="loading" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
      <widgetNotfound v-else title="No Data Found" subtitle="No records available at the moment. Add New">
      </widgetNotfound>
    </div>
    <AddNewOthers v-if="toggleModal" @refresh="loading = true; getAllMedia();"
      @closeModal="toggleModal = false; selected_data = null" :dataObj="selected_data" />
  </div>
</template>

<script>
import AddNewOthers from './modals/addNewOther.vue';
import dataCard from './components/dataCard.vue';
import TabsWidget from './components/TabsWidget.vue';
export default {
  data() {
    return {
      toggleModal: false,
      selected_data: null,
      loading: true,
      allData: []
    }
  },
  components: { dataCard, AddNewOthers, TabsWidget },
  mounted() {
    let vm = this;
    vm.getAllMedia();
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    edit(data) {
      let vm = this;
      vm.selected_data = data
      vm.toggleModal = true
    },
    getAllMedia() {
      let vm = this;
      vm.$store.dispatch('GET_AUD_VID_BY_TYPE', { type: 'others' })
        .then((res) => {
          vm.loading = false
          vm.allData = res.data
        })
        .catch((err) => {
          vm.loading = false
          vm.allData = []
        })
    },
    deleteMedia(data) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Delete Media',
        message: 'Are you sure you want to delete this media?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_AUD_VID', { id: data.id })
            .then((res) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Media Deleted Successfully',
              });
              vm.loading = true;
              vm.getAllMedia();
            })
            .catch((err) => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
            })
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: fit-content;
    // height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(6, calc(100%/6.4));
    row-gap: 50px;
    overflow-y: auto;
    justify-content: space-between;

    @media (max-width: 1307px) {
      grid-template-columns: repeat(5, calc(100%/5.3));
    }

    @media (max-width: 1000px) {
      grid-template-columns: repeat(4, calc(100%/4.25));
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(3, calc(100%/3.15));
      row-gap: 30px;
    }

    @media (max-width: 600px) {
      grid-template-columns: repeat(2, calc(100%/2.05));
    }

    @media (max-width: 450px) {
      grid-template-columns: repeat(1, 1fr);
    }

    &.activeSide {
      grid-template-columns: repeat(5, calc(100%/5.3));

      @media (max-width: 1300px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }

      @media (max-width: 1100px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
      }

      @media (max-width: 966px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
        row-gap: 30px;
      }

      @media (max-width: 600px) {
        grid-template-columns: repeat(2, calc(100%/2.05));
      }

      @media (max-width: 450px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }
}
</style>
